import axios from 'axios'

class RequestSignatureReplicationService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    async getRequestDocumentDownload(token, requestId) {
        let response = await axios.get(`${this.apiUrl}/request-document-download?requestId=${requestId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }
    async getRequestDocumentInformation(token, requestId) {
        let response = await axios.get(`${this.apiUrl}/request?id=${requestId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }
    async postRequestSignatureReplication(token, { userEmail }) {
        let response = await axios.post(`${this.apiUrl}/request-signature-replication`, { userEmail }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }

    async postRequestSignatureReplicationReport(token, data) {
        let response = await axios.post(`${this.apiUrl}/request-signature-replication-report`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }
    async postSendPdfRequestSignatureReplicationReport(token, data) {
        let response = await axios.post(`${this.apiUrl}/request-send-report`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }
}


export { RequestSignatureReplicationService as default }
